import React, { Component } from "react";
import { bool } from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import "./Timesheet.css";

import {
	fetchTimsheetsForUser,
	updateTimesheets
} from "../../../actions/timesheet.js";
import {
	fetchLeavesForUser,
	updateLeaves,
	deleteLeave
} from "../../../actions/leave.js";
import Modal from "../../../common/modal/Modal.js";
import TimesheetEntry from "./_common/TimesheetEntry.js";
import TimesheetHeader from "./_common/TimesheetHeader.js";
import TimesheetSubheader from "./_common/TimesheetSubheader.js";
import TimesheetTotal from "./_common/TimesheetTotal.js";
import TimesheetOvertime from "./_common/TimesheetOvertime.js";
import LeaveEntry from "./_common/LeaveEntry.js";
import FaSave from "react-icons/lib/fa/floppy-o";
import FaLeft from "react-icons/lib/fa/arrow-left";
import FaRight from "react-icons/lib/fa/arrow-right";

class Timesheet extends Component {
	static propTypes = {
		readOnly: bool
	};

	constructor(props) {
		super(props);

		this.state = {
			startDate: "",
			endDate: "",
			timesheets: [],
			leaves: [],
			loading: true,
			showModal: false,
			deleteId: null
		};

		this.getTotals = this.getTotals.bind(this);
		this.getStartDate = this.getStartDate.bind(this);
		this.dayHoursChangeHandler = this.dayHoursChangeHandler.bind(this);
		this.leaveChangeHandler = this.leaveChangeHandler.bind(this);
		this.focusHandler = this.focusHandler.bind(this);
		this.onSaveDataClick = this.onSaveDataClick.bind(this);
		this.onGoBackClick = this.onGoBackClick.bind(this);
		this.onGoForwardClick = this.onGoForwardClick.bind(this);
	}

	/**
	 * Get the start date of timesheet
	 */
	getStartDate() {
		let date = moment();

		// Check if it is monday aka dayofWeek === 1
		if (date.day() !== 1) {
			while (date.day() !== 1) {
				date = date.subtract(1, "day");
			}
		}
		// save date to startDate & date + 7 days to endDate
		this.setState({
			startDate: date.format("YYYY-MM-DD"),
			endDate: date.add(6, "days").format("YYYY-MM-DD")
		});
	}

	focusHandler(e) {
		e.target.select();
	}

	/**
	 * Change handler for timesheet entry inputs
	 * @param {object} e
	 * @param {object} args
	 */
	dayHoursChangeHandler(e, args) {
		const targetValue = isNaN(parseInt(e.target.value, 10))
			? 0
			: parseInt(e.target.value, 10);

		args = Object.assign({ hours: targetValue }, args);

		let changedProject = this.state.timesheets.filter(
			ts => ts.project_id === args.project_id
		)[0];
		changedProject.entries[args.day] = args.hours;
		changedProject["updated"] = true;

		const updatedHoursByProject = [
			...this.state.timesheets.filter(ts => ts.project_id !== args.project_id),
			changedProject
		].sort((a, b) => a.project.name.localeCompare(b.project.name));
		this.setState({ hoursByProject: updatedHoursByProject });
	}

	/**
	 * Change handler for leave entry inputs in timesheet
	 * @param {object} e
	 * @param {object} args
	 */
	leaveChangeHandler(e, args) {
		const targetValue = isNaN(parseInt(e.target.value, 10))
			? 0
			: parseInt(e.target.value, 10);

		args = Object.assign({ hours: targetValue }, args);

		let changedLeave = this.state.leaves.filter(
			le => le.leave_type_id === args.leave_type_id
		)[0];
		changedLeave.entries[args.day] = args.hours;
		changedLeave["updated"] = true;

		const updatedLeavesByType = [
			...this.state.leaves.filter(
				le => le.leave_type_id !== args.leave_type_id
			),
			changedLeave
		].sort((a, b) =>
			a.leave_type.display_name.localeCompare(b.leave_type.display_name)
		);
		this.setState({ hoursByLeave: updatedLeavesByType });
	}

	/**
	 * Method for sending update action to backend & redux store
	 */
	onSaveDataClick() {
		// const leaves = this.state.leaves.filter(l => l.from && l.to && l.type);
		this.props.updateTimesheets(
			this.props.currentUser.id,
			this.state.timesheets
		);
		this.props.updateLeaves(this.props.currentUser.id, this.state.leaves);
	}

	/**
	 * Click handler for back button. startDate - 7d
	 */
	onGoBackClick() {
		const newStartDate = moment(this.state.startDate)
			.subtract(1, "week")
			.format("YYYY-MM-DD");
		const newEndDate = moment(this.state.endDate)
			.subtract(1, "week")
			.format("YYYY-MM-DD");
		this.setState({ startDate: newStartDate, endDate: newEndDate });
	}

	/**
	 * Click handler for forward button. startDate + 6d
	 */
	onGoForwardClick() {
		const newStartDate = moment(this.state.startDate)
			.add(1, "week")
			.format("YYYY-MM-DD");
		const newEndDate = moment(this.state.endDate)
			.add(1, "week")
			.format("YYYY-MM-DD");
		this.setState({ startDate: newStartDate, endDate: newEndDate });
	}

	/**
	 * get day : totalHours map
	 * @returns {Map}
	 */
	getTotals() {
		const totals = new Map();

		const days = [...Array(7)].map((_, i) => {
			let day = moment(this.state.startDate);
			day = day.add(i, "days");
			return day.format("YYYY-MM-DD");
		});

		for (let d of days) {
			totals.set(d, 0);
			for (let ts of this.state.timesheets) {
				if (typeof ts.entries[d] !== "undefined") {
					totals.set(d, totals.get(d) + ts.entries[d]);
				}
			}

			for (let le of this.state.leaves) {
				if (typeof le.entries[d] !== "undefined") {
					totals.set(d, totals.get(d) + le.entries[d]);
				}
			}
		}
		return totals;
	}

	componentDidMount() {
		this.getStartDate();
		const userId = this.props.userId || this.props.currentUser.id;
		this.props.fetchTimsheetsForUser(userId);
		this.props.fetchLeavesForUser(userId);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.timesheets.length > 0) {
			this.setState({ timesheets: nextProps.timesheets, loading: false });
		}

		if (nextProps.leaves.length > 0) {
			this.setState({ leaves: nextProps.leaves, loading: false });
		}
	}

	render() {
		const { timesheets, leaves } = this.state;
		const receivedTimesheets = timesheets.length > 0;
		const receivedLeaves = leaves.length > 0;

		const timesheetEntries =
			receivedTimesheets &&
			timesheets.map((ts, i) => {
				return (
					<TimesheetEntry
						key={i}
						project_id={ts.project_id}
						project={ts.project.name}
						donor={ts.project.donors.reduce(
							(str, d) =>
								str.length === 0 ? (str += d.name) : (str += ", " + d.name),
							""
						)}
						startDate={this.state.startDate}
						endDate={this.state.endDate}
						entries={ts.entries}
						focusHandler={this.focusHandler}
						changeHandler={this.dayHoursChangeHandler}
						readOnly={this.props.readOnly}
					/>
				);
			});

		const leaveEntries =
			receivedLeaves &&
			leaves.map((le, i) => {
				return (
					<LeaveEntry
						key={i}
						leave_type_id={le.leave_type_id}
						leave_type={le.leave_type.display_name}
						startDate={this.state.startDate}
						endDate={this.state.endDate}
						entries={le.entries}
						focusHandler={this.focusHandler}
						changeHandler={this.leaveChangeHandler}
						readOnly={this.props.readOnly}
					/>
				);
			});

		if (this.state.loading) {
			return <div>Loading...</div>;
		} else {
			return (
				<div className="timesheet">
					<time className="timesheetRange">
						<button onClick={this.onGoBackClick}>
							<FaLeft size={24} />
						</button>
						<div>
							{this.state.startDate} &mdash; {this.state.endDate}
						</div>
						<button onClick={this.onGoForwardClick}>
							<FaRight size={24} />
						</button>
					</time>
					<section>
						<table
							cellPadding="0"
							cellSpacing="0"
							className="timesheetEntryTable"
						>
							<tbody>
								<TimesheetHeader user={this.props.currentUser} />
								<tr className="timesheetEntrySubheader">
									<td colSpan="2">Other activities</td>
									{[...Array(7)].map((_, i) => {
										let day = new Date(this.state.startDate);
										day.setDate(day.getDate() + i);
										day = day.toISOString().substring(5, 10);
										return (
											<td
												key={i}
												className="timesheetEntryDataWD"
												style={{ borderRight: "1px solid #333" }}
											>
												{day}
											</td>
										);
									})}
								</tr>
								{leaveEntries}
								{receivedTimesheets && (
									<TimesheetSubheader startDate={this.state.startDate} />
								)}
								{timesheetEntries}
								<TimesheetTotal
									totalsHandler={this.getTotals}
									totals={Array.from(this.getTotals().values())}
								/>
								<TimesheetOvertime totalsHandler={this.getTotals} />
							</tbody>
						</table>
						{this.state.showModal && (
							<Modal
								type="CONFIRMATION"
								onConfirm={this.onDeleteLeaveConfirm}
								onCancel={() => this.setState({ showModal: false })}
								show={this.state.showModal}
							>
								Are you sure?
							</Modal>
						)}
					</section>
					{!this.props.readOnly && (
						<button
							onClick={this.onSaveDataClick}
							className="btn-green save-btn"
						>
							<FaSave /> Save data
						</button>
					)}
				</div>
			);
		}
	}
}

const mapStateToProps = state => {
	return {
		timesheets: state.timesheet.user,
		leaves: state.leave.all,
		currentUser: state.auth.currentUser
	};
};

export default connect(
	mapStateToProps,
	{
		fetchTimsheetsForUser,
		fetchLeavesForUser,
		updateTimesheets,
		updateLeaves,
		deleteLeave
	}
)(Timesheet);



// WEBPACK FOOTER //
// ./src/components/main/timesheet/Timesheet.js